<template>
  <div
    ref="parent"
    class="input-tel"
    @click="focusInput"
    @mouseenter="updateHoverState(true)"
    @mouseleave="updateHoverState(false)"
  >
    <input
      id="InputTel"
      ref="InputTel"
      autocomplete="off"
      v-model="inputValue"
      v-bind="$attrs"
      v-mask="mask"
      :placeholder="placeholder"
      type="tel"
      name="telephone"
      class="input-tel__input"
      @keydown="$emit('keydown', $event)"
      @focus="onFocus"
      @blur="onBlur"
      @click="$emit('click', $event)"
    >
  </div>
</template>

<script>

export default {
  name: 'InputTel',
  props: {
    value: { type: [String, Number], default: null },
    valid: { type: Boolean, default: false },
    example: { type: String, default: '0000 0000' }
  },
  data () {
    return {
      isFocus: false,
      isHover: false
    }
  },
  computed: {
    inputValue: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    mask () {
      return this.example.replace(/[0-9]/g, '#')
    },
    placeholder () {
      return this.example.replace(/[0-9]/g, '0')
    }
  },
  methods: {
    updateHoverState (value) {
      this.isHover = value
    },
    focusInput () {
      this.$refs.InputTel.focus()
    },
    onFocus: function () {
      this.$emit('focus')
      this.isFocus = true
    },
    onBlur: function () {
      this.$emit('blur')
      this.isFocus = false
    },
    clear () {
      this.$emit('input', null)
      this.$emit('clear')
    }
  }
}
</script>
